module.exports = __webpack_public_path__ + "img/edit.cfce415c.svg";